pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

function renderPdpPdfCanvas(canvas, targetWidth = 300) {
    const pdfUrl = canvas.dataset.pdfUrl;
    if (!pdfUrl || canvas.dataset.rendered === 'true') return;

    canvas.dataset.rendered = 'true';
    canvas.style.background = '#f0f0f0';

    pdfjsLib.getDocument(pdfUrl).promise
        .then(pdf => pdf.getPage(1))
        .then(page => {
            const naturalViewport = page.getViewport({ scale: 1 });
            const scale = targetWidth / naturalViewport.width;
            const viewport = page.getViewport({ scale });

            canvas.width = viewport.width;
            canvas.height = viewport.height;
            canvas.style.width = '100%';
            canvas.style.height = 'auto';
            canvas.style.background = '';

            return page.render({
                canvasContext: canvas.getContext('2d'),
                viewport
            }).promise;
        })
        .catch(err => {
            console.warn('PDF render error:', pdfUrl, err);
            canvas.dataset.rendered = 'error';
        });
}

const accordionObserver = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        if (mutation.type !== 'attributes') return;

        const target = mutation.target;
        if (target.classList.contains('is-open')) {
            target.querySelectorAll('.pdf-canvas').forEach(canvas => {
                renderPdpPdfCanvas(canvas, 300);
            });
        }
    });
});

document.querySelectorAll('.pdp-lab-reports__item__content').forEach(el => {
    accordionObserver.observe(el, {
        attributes: true,
        attributeFilter: ['class']
    });
});

// Рендерим уже открытые при загрузке
document.querySelectorAll('.pdp-lab-reports__item__content.is-open').forEach(el => {
    el.querySelectorAll('.pdf-canvas').forEach(canvas => {
        renderPdpPdfCanvas(canvas, 300);
    });
});